import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { useContratoListaViewModel } from "../../viewModels/contrato_lista_view_model";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useMemo } from "react";
import { GenerateContratoColumns } from "./columns";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useNavigate } from "react-router";
import { ContratoLista } from "../../../domain/models/contrato_lista";


export const Contrato_lista = () => {
  const navigate = useNavigate();
  const viewModel = useContratoListaViewModel();
  const ContratoListalColumns = useMemo(() => {
    return GenerateContratoColumns({
      onActionEditar: viewModel.handleCadastroContratoOpenState,
      onActionDeletar: viewModel.handleDeleteContratoModalOpenState,
    });
  }, [viewModel.handleCadastroContratoOpenState, viewModel.handleDeleteContratoModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[100px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => navigate("/Contrato_Cadastro/")}>
                  Novo
                </PrimaryButton>
              </div>
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-6 flex-col md:p-10 px-4 pt-8 mb-12">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Terceirização
            </Link>
            <Typography className="text-primary-green">
              Contrato lista
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Contrato Lista</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            centroDeCusto={viewModel.filters.centroDeCusto}
            centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
            FornecedorPesquisa={viewModel.filters.FornecedorPesquisa}
            NDocumentoPesquisa={viewModel.filters.NDocumentoPesquisa}
            StatusPesquisa={viewModel.filters.StatusPesquisa}
            Documentos={viewModel.filters.DocumentosPesquisa}
            handleFornecedorChange={viewModel.handleFornecedorChange}
            handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
            handleDocumentos={viewModel.handleDocumentosChange}
            handleNDocumentoCampoChange={viewModel.handleNDocumentoCampoChange}
            handleStatusPesquisa={viewModel.handleStatusPesquisaChange}
            Assinado={viewModel.filters.AssinadoPesquisa}
            handleAssinado={viewModel.handleAssinadoChange}
          />
          <StyledDataGrid
            tableName="Contrato_lista"
            disableColumnMenu={false}
            disableRowSelectionOnClick={true}
            getRowId={(row: ContratoLista) => row.IdContrato}
            columns={ContratoListalColumns}
            loading={viewModel.loading}
            rows={viewModel.contratoLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ['IdContrato'],
            }}
            autoHeight={true}
            textSize="medio"
            getRowHeight={() => "auto"}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>

      </form>

      <DeleteDialog
        open={viewModel.contratoDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteContratoModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaContrato} />
    </>
  );

}


